import { render, staticRenderFns } from "./GrupoConta.vue?vue&type=template&id=0f40e8cc&scoped=true&"
import script from "./GrupoConta.vue?vue&type=script&lang=js&"
export * from "./GrupoConta.vue?vue&type=script&lang=js&"
import style0 from "./GrupoConta.vue?vue&type=style&index=0&id=0f40e8cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f40e8cc",
  null
  
)

export default component.exports